import React, { useState } from "react";
import "./EditModelForm.css"; 

console.log("This is model Search");

const EditModelForm = ({ model, onClose, onSave }) => {
  const [formData, setFormData] = useState({
    model_name: model.asset1_name || '',
    model_code: model.asset1_code || '',
    status: model.status || ""
  });
  
  // 1. Add loading state
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true); 

    try {
      const response = await fetch(
        `/api/models/update-model/${model.asset1_code}`,
        {
          method: "PUT",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(formData),
        }
      );

      if (!response.ok) throw new Error("Failed to update model.");

      const updatedmodel = { ...model, ...formData };
      onSave(updatedmodel);
      onClose();
    } catch (error) {
      console.error("Error updating model:", error);
      alert("Error saving changes. Please try again.");
    } finally {
      setIsSubmitting(false); 
    }
  };

  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <button className="close-button" onClick={onClose} aria-label="Close" disabled={isSubmitting}>✖</button>
        <h3>Edit Model</h3>
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label>Model Name:</label>
            <input 
              type="text" 
              name="model_name" 
              value={formData.model_name} 
              onChange={handleChange} 
              required 
              disabled={isSubmitting} 
            />
          </div>

          <div className="form-group">
            <label>Model Code:</label>
            <input 
              type="text" 
              name="model_code" 
              value={formData.model_code} 
              onChange={handleChange} 
              required 
              disabled={isSubmitting}
            />
          </div>

          <div className="form-group">
            <label>Status:</label>
            <select 
              name="status" 
              value={formData.status} 
              onChange={handleChange} 
              required
              disabled={isSubmitting}
            >
              <option value="">Select Status</option>
              <option value="Active">Active</option>
              <option value="Inactive">Inactive</option>
            </select>
          </div>

          <div className="modal-actions">
            {/* 2. Button changes based on loading state */}
            <button 
                type="submit" 
                className={`save-button ${isSubmitting ? 'loading' : ''}`}
                disabled={isSubmitting}
            >
              {isSubmitting ? "Saving..." : "Save Changes"}
            </button>
            <button 
                type="button" 
                className="cancel-button" 
                onClick={onClose} 
                disabled={isSubmitting}
            >
                Cancel
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default EditModelForm;